import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    component: () => import('@/views/AccessDenied.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/views/dashboard/DashboardView.vue')
      },
      {
        path: 'daily-email',
        name: 'daily-email-list',
        component: () => import('@/views/daily-email/DailyEmailList.vue')
      },
      {
        path: 'daily-email/new',
        name: 'daily-email-new',
        component: () => import('@/views/daily-email/DailyEmailEditor.vue')
      },
      {
        path: 'daily-email/:id',
        name: 'daily-email-edit',
        component: () => import('@/views/daily-email/DailyEmailEditor.vue')
      },
      {
        path: 'instant-email',
        name: 'instant-email-list',
        component: () => import('@/views/instant-email/InstantEmailList.vue')
      },
      {
        path: 'instant-email/new',
        name: 'instant-email-new',
        component: () => import('@/views/instant-email/InstantEmailEditor.vue')
      },
      {
        path: 'instant-email/:id',
        name: 'instant-email-edit',
        component: () => import('@/views/instant-email/InstantEmailEditor.vue')
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/views/settings/SettingsView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  // Wait for auth to finish loading (max 5 seconds)
  const maxWait = 100 // 100 * 50ms = 5 seconds
  let waitCount = 0
  while (authStore.loading && waitCount < maxWait) {
    await new Promise(resolve => setTimeout(resolve, 50))
    waitCount++
  }

  // Routes that don't require auth
  if (to.meta.requiresAuth === false) {
    // Login page: redirect to dashboard if already authenticated
    if (to.name === 'login' && authStore.isAuthenticated && authStore.isAllowed) {
      next({ name: 'dashboard' })
    } else {
      next()
    }
    return
  }

  // Protected routes require authentication
  if (!authStore.isAuthenticated) {
    next({ name: 'login' })
    return
  }

  // Check if user is allowed
  if (!authStore.isAllowed) {
    next({ name: 'access-denied' })
    return
  }

  // All checks passed
  next()
})

export default router
